import { useAuthStore, useAuthTokenStore } from '../store/authStore';
import { usePageOwnerIdentityStore } from '../store/pageOwnerIdentityStore';

export const useIsPageOwner = (): boolean => {
  const userAui = useAuthStore((state) => state.user?.aui);
  const hasAuthToken = useAuthTokenStore((state) => Boolean(state.authToken));
  const pageOwnerAui = usePageOwnerIdentityStore((state) => state.pageOwner?.aui);

  return hasAuthToken && pageOwnerAui != null && userAui === pageOwnerAui;
};
